export default __webpack_public_path__ + "static/media/2566.f46df52d.png";